import React, { useContext, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../components";
import { useForm } from "../../hooks";
import { loginFormValidations } from "../../helpers/formValidations";
import { reqToUserLogin } from "../../store/slice/userSlice";
import { dateFormatWithTime } from "../../helpers/commonFunction";

const LoginPage = ({ userRole }) => {
  const dispatch = useDispatch();
  const { loader } = useSelector((state) => state.userReducer);

  const initialFValues = {
    username: "",
    password: "",
    type: userRole || "ADMIN",
  };
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    return loginFormValidations(
      fieldValues,
      temp,
      values,
      setValues,
      setErrors
    );
  };
  const { errors, setErrors, values, setValues, handleInputChange } = useForm(
    initialFValues,
    true,
    validate
  );

  const handleUserLogin = (e) => {
    e.preventDefault();
    dispatch(
      reqToUserLogin({
        data: { ...values, date: dateFormatWithTime(new Date()) },
        onSuccess: () => {},
        onFailure: () => {},
      })
    );
  };

  return (
    <>
      {loader && <Loader />}
      <div className="tc-login-section">
        <div className="tc-navbar"></div>
        <div className="tc-login-content">
          <Form className="tc-login-form">
            <div className="tc-login-top-space"></div>
            <div className="tc-login-form-box">
              <div
                className="tc-login-logo"
                style={{ padding: "30px 15px 15px 15px" }}
              >
                <div className="logo-title">
                  <h2 className="text-center" style={{ fontSize: "35px" }}>
                  TCL
                    <span style={{ display: "block" }}>
                      {userRole || "Admin"} APP
                    </span>
                  </h2>
                </div>
                <div className="version tc_version_content">
                  <p>
                    {process.env.REACT_APP_SERVER} Version{" "}
                    {process.env.REACT_APP_VERSION}
                  </p>
                </div>
              </div>
              <Form.Group className="tc-login-form-list">
                <div className="tc-login-form-list-input-row mb-3">
                  <Form.Control
                    type="text"
                    name="username"
                    value={values.username}
                    onChange={handleInputChange}
                    placeholder="Username"
                    className="text-center"
                  />
                  <span className="tc_error_text justify-content-center">
                    {errors && errors.username}
                  </span>
                </div>
              </Form.Group>
              <Form.Group className="tc-login-form-list">
                <div className="tc-login-form-list-input-row">
                  <Form.Control
                    type="password"
                    name="password"
                    value={values.password}
                    onChange={handleInputChange}
                    placeholder="Password"
                    className="text-center"
                  />
                  <span className="tc_error_text justify-content-center">
                    {errors && errors.password}
                  </span>
                </div>
              </Form.Group>
              <div className="text-center">
                <Button
                  variant="green"
                  className="login-button mt-5"
                  type="submit"
                  onClick={(e) => handleUserLogin(e)}
                >
                  Login
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 4.5l7.5 7.5-7.5 7.5"
                    />
                  </svg>
                </Button>
              </div>
            </div>
          </Form>
        </div>
        <div className="tc-footer-blank d-flex justify-content-center"></div>
      </div>
    </>
  );
};

export default LoginPage;
